import { useAssetImportFeedback } from './hooks/useAssetImportFeedback';
import { useAssetImportMapping } from './hooks/useAssetImportMapping';
import { useAssetImportReferenceData } from './hooks/useAssetImportReferenceData';
import { useAssetImportUpload } from './hooks/useAssetImportUpload';

export function useAssetImportMatchy() {
  const feedback = useAssetImportFeedback();
  const referenceData = useAssetImportReferenceData({
    setErrorAction: feedback.setError,
  });
  const mapping = useAssetImportMapping({
    resetSelectionAction: referenceData.resetSelection,
    setConfirmationMessageAction: feedback.setConfirmationMessage,
    setErrorAction: feedback.setError,
    setStatusAction: feedback.setStatus,
  });
  const upload = useAssetImportUpload({
    currentSuggestions: mapping.currentSuggestions,
    fileName: mapping.fileName,
    rawHeaders: mapping.rawHeaders,
    rawRows: mapping.rawRows,
    selectedAssetModelId: referenceData.selectedAssetModelId,
    selectedAssetTypeId: referenceData.selectedAssetTypeId,
    setConfirmationMessageAction: feedback.setConfirmationMessage,
    setCsvRowsAction: mapping.setCsvRows,
    setErrorAction: feedback.setError,
    setStatusAction: feedback.setStatus,
    stagedUploadRows: mapping.stagedUploadRows,
  });

  return {
    assetModels: referenceData.assetModels,
    assetTypes: referenceData.assetTypes,
    confirmationMessage: feedback.confirmationMessage,
    csvRows: mapping.csvRows,
    currentSuggestions: mapping.currentSuggestions,
    error: feedback.error,
    fileName: mapping.fileName,
    handleConfirmMapping: mapping.handleConfirmMapping,
    handleFileLoaded: mapping.handleFileLoaded,
    handleMappingChange: mapping.handleMappingChange,
    handleSubmitData: mapping.handleSubmitData,
    handleUploadData: upload.handleUploadData,
    isLoadingAssetModels: referenceData.isLoadingAssetModels,
    isLoadingAssetTypes: referenceData.isLoadingAssetTypes,
    previewColumns: mapping.previewColumns,
    selectedAssetModelId: referenceData.selectedAssetModelId,
    selectedAssetTypeId: referenceData.selectedAssetTypeId,
    setSelectedAssetModelId: referenceData.setSelectedAssetModelId,
    setSelectedAssetTypeId: referenceData.setSelectedAssetTypeId,
    stagedUploadRows: mapping.stagedUploadRows,
    status: feedback.status,
  };
}
